import React from "react";
// Import the routing components
import { Routes, Route } from "react-router-dom";
import "./App.css";

// Import all your page components
import Navbar from "./Navbar";
import Home from "./Home";
import Products from "./Products";
import ProductDetail from "./ProductDetail";
import Contact from "./Contact";

function App() {
    return (
        <div className="App">
            <Navbar />

            {/* The Routes block defines what component is shown */}
            <Routes>
                {/* Define the URL paths for each component */}
                <Route path="/" element={<Home />} />
                <Route path="/products" element={<Products />} />
                <Route path="/products/:id" element={<ProductDetail />} />
                <Route path="/contact" element={<Contact />} />
            </Routes>
        </div>
    );
}

export default App;
